import React from "react";

function TheFoundation() {
  return (
    <>
      <div
        className="about-style-three-area default-padding bg-gray bg-cover"
        style={{ background: "url(assets/img/shape/banner-16.html)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h4 className="sub-title">OP Stack</h4>
              <h2 className="title split-text-right split-text-in-right">
                OP Stack: The Foundation for Scalable Ethereum Solutions
              </h2>
              <p>
                The OP Stack offers a modular, open-source development framework
                designed for Ethereum-compatible applications. Its modular
                architecture allows for the creation of layer-2 solutions that
                reduce congestion and transaction costs while maintaining
                Ethereum’s security and decentralization.
              </p>
              {/* <p>
                We integrate multi-currency support, advanced encryption,
                KYC/AML compliance, and cross-platform compatibility, creating a
                versatile wallet that can handle transactions and engage with
                the broader Web3 ecosystem. From DeFi and NFTs to smart contract
                interaction, our Web3 wallets are optimized for performance,
                security, and a superior user experience.
              </p> */}
              <a className="btn btn-style-one" href="#">
                Know more
              </a>
            </div>
            <div className="col-lg-6">
              <div className="about-style-three-thumb">
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/dashboard-4.jpg"
                  alt="Image Not Found"
                />
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/1.gif"
                  alt="Image Not Found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TheFoundation;
